export default __webpack_public_path__ + "static/media/speech-babel.71fa0b0b.svg";